import { createContext, useReducer, useContext} from "react";

const ChatboxState = {
    valueOpen: false,
    canSendDataToServer: true,
    valueDotBubble: false,
    toggleMargin : false,
    valueToggleFocus : true,
    valueTogglePath : false,
    valueToggleSound : false,
    valueToggleVariablesList : false,
    restartChatbox : false,
};

const ChatboxReducer = (state, action) => {
  switch (action.type) {
    case "openAndClose":
      return { ...state, valueOpen: !state.valueOpen, restartChatbox : !state.restartChatbox };
    case "toggleFocus":
      return { ...state, valueToggleFocus: !state.valueToggleFocus };
    case "togglePath":
        if (state.valueToggleVariablesList == true){
          state = { ...state, valueToggleVariablesList: !state.valueToggleVariablesList }
        }
        return { ...state, valueTogglePath: !state.valueTogglePath };
    case "toggleSound":
      return { ...state, valueToggleSound: !state.valueToggleSound };
    case "toggleVariablesList":
      if (state.valueTogglePath == true){
        state = { ...state, valueTogglePath: !state.valueTogglePath }
      }
      return { ...state, valueToggleVariablesList: !state.valueToggleVariablesList };
    case "forceOpen":
      return { ...state, valueOpen: true };
    case "setCanSendDataToServer":
      return { ...state, canSendDataToServer: action.payload.value };
    case "addDotBubble":
      return { ...state, valueDotBubble: !state.valueDotBubble };
    case "toggleMargin":
      return { ...state, toggleMargin: !state.toggleMargin };
    default:
      return state;

  }
}

const ChatboxStateContext = createContext(ChatboxState);
const ChatboxDispatchContext = createContext(null);

function ChatboxContextProvider({ children }) {
  const [state, dispatch] = useReducer(ChatboxReducer, ChatboxState);
  return (
    <ChatboxStateContext.Provider value={{...state}}>
      <ChatboxDispatchContext.Provider value={dispatch}>
        {children}
      </ChatboxDispatchContext.Provider>
    </ChatboxStateContext.Provider>
  );
}

export default ChatboxContextProvider;

export const useChatboxStateContext = () => useContext(ChatboxStateContext);
export const useChatboxDispatchContext = () => useContext(ChatboxDispatchContext);
